import type { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

// Query path inspirations

export const query = graphql(`
    query AppInspirationsQuery($id: ID!) {
        learningPath(id: $id) {
            id
            inspirations {
                id
                created
                content
                read
                liked
                likeCount
            }
        }
    }
`);

export type IInspiration = ResultOf<typeof query>["learningPath"]["inspirations"][number];

// Toggle like mutation

export const likeMutation = graphql(`
    mutation AppInspirationChangeLikeMutation($id: ID!, $to: String!) {
        inspirationChangeLike(id: $id, to: $to) {
            error
            inspiration { id }
        }
    }
`);

// Mark read mutation

export const markReadMutation = graphql(`
    mutation AppInspirationMarkReadsMutation($ids: [ID!]!) {
        inspirationMarkReads(ids: $ids) {
            error
        }
    }
`);

// Mark unread mutation

export const markUnreadMutation = graphql(`
    mutation AppInspirationMarkUnreadMutation($id: ID!) {
        inspirationMarkUnread(id: $id) {
            error
            inspiration { id }
        }
    }
`);
